<p8-layout-settings-logo-title title="ARCHIVES PAPIERS"
                               align="end"
                               logo="secondary"
                               ></p8-layout-settings-logo-title>

<div class="main-content">
  <p8-disclaimer-test></p8-disclaimer-test>
  <app-home-boutons-applicant></app-home-boutons-applicant>
  <ng-container *ngIf="isGestionnaire">
    <app-dashboard [expanded]=true></app-dashboard>
  </ng-container>
</div>
<router-outlet></router-outlet>
